import script from "./AlzguardIntroductionCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./AlzguardIntroductionCard.vue?vue&type=script&setup=true&lang=ts"

import "./AlzguardIntroductionCard.vue?vue&type=style&index=0&id=a11f3da8&lang=css"

const __exports__ = script;

export default __exports__